__turbopack_context__.v({
  "brandHeading": "BrandLogosMba-module-scss-module__M8vb0G__brandHeading",
  "brandHeadingMba": "BrandLogosMba-module-scss-module__M8vb0G__brandHeadingMba",
  "brandImage": "BrandLogosMba-module-scss-module__M8vb0G__brandImage",
  "brandWrapper": "BrandLogosMba-module-scss-module__M8vb0G__brandWrapper",
  "brandsLogoContainer": "BrandLogosMba-module-scss-module__M8vb0G__brandsLogoContainer",
  "brandsMarquee": "BrandLogosMba-module-scss-module__M8vb0G__brandsMarquee",
  "statebrandHeading": "BrandLogosMba-module-scss-module__M8vb0G__statebrandHeading",
});
